<template>
  <SectionPageShell section="inquiries" :title="title" subtitle="Anfragen" show-back-link>
    <div class="card border-0 shadow-sm">
      <div class="card-body p-3 p-lg-4">
        <div v-if="!inquiry" class="text-muted">Anfrage wird geladen...</div>
        <template v-else>
          <p class="small text-muted">
            {{ formatDate(inquiry.in_at, 'datetime') }} · {{ inquiry.route }} · {{ inquiry.sender }}
          </p>
          <!-- Submitted values in historic mails are not escaped: an empty sandbox blocks scripts and same-origin access. -->
          <iframe
            v-if="inquiry.format === 'html' && inquiry.body"
            :srcdoc="inquiry.body"
            sandbox=""
            title="Anfrage"
            class="inquiry-frame"
          ></iframe>
          <pre v-else-if="inquiry.body" class="inquiry-text">{{ inquiry.body }}</pre>
          <p v-else-if="inquiry.format === 'pdf'" class="text-muted mb-0">Diese Anfrage wurde per Fax zugestellt.</p>
          <p v-else class="text-muted mb-0">Der Inhalt dieser Anfrage ist nicht mehr verfügbar.</p>
        </template>
      </div>
    </div>
  </SectionPageShell>
</template>

<script>
import SectionPageShell from "@/components/base_type/SectionPageShell.vue";
import { useInquiriesStore } from "@/stores/inquiries";

export default {
  name: "InquiriesShowPage",
  components: {
    SectionPageShell,
  },
  setup() {
    return {
      inquiriesStore: useInquiriesStore(),
    }
  },
  data() {
    return {
      inquiry: null,
    }
  },
  async created() {
    this.inquiry = await this.inquiriesStore.show(this.$route.params.id)
  },
  computed: {
    title() {
      return this.inquiry?.subject || 'Anfrage'
    },
  },
}
</script>

<style scoped lang="scss">
.inquiry-frame {
  width: 100%;
  min-height: 70vh;
  border: 1px solid #dce4ea;
}

.inquiry-text {
  white-space: pre-wrap;
}
</style>
